module.exports = __webpack_public_path__ + "media/images/flags/64/Panama-eb38abbca754162c5891b12b451e201e.png";